/**
 * Aspect — AI provider preference (browser localStorage)
 * Composer/Cursor models run only inside the IDE; this app uses Auto, Demo,
 * Claude, GPT-4o, Astra 6, or Astra 6 Pro (OpenRouter).
 */

export const PROVIDER_OPTIONS = [
  { id: "auto", label: "Auto", hint: "Astra 6 Pro when the OpenRouter key is set" },
  { id: "demo", label: "Demo", hint: "No API key needed" },
  { id: "astra", label: "Astra 6", hint: "Recommended for chat" },
  { id: "astra-pro", label: "Astra 6 Pro", hint: "Best for 2D plan upload" },
  // "Atrium" is Aspect's model name — it still routes to Claude (Anthropic) underneath.
  { id: "anthropic", label: "Atrium", hint: "Anthropic API key" },
  { id: "openai", label: "GPT-4o", hint: "OpenAI API key" },
];

const STORAGE_KEY = "aspect-ai-provider";

export function getAiProvider() {
  const v = localStorage.getItem(STORAGE_KEY) ?? "auto";
  return PROVIDER_OPTIONS.some((o) => o.id === v) ? v : "auto";
}

export function setAiProvider(id) {
  if (PROVIDER_OPTIONS.some((o) => o.id === id)) {
    localStorage.setItem(STORAGE_KEY, id);
  }
}
